import { render, staticRenderFns } from "./CampCoupons.vue?vue&type=template&id=61b273f0&"
import script from "./CampCoupons.vue?vue&type=script&lang=js&"
export * from "./CampCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports